



























import Vue from 'vue';
import RuleTypeBox from './RuleTypeBox.vue';
import { ScheduleRuleType } from '../../../models/ScheduleRule';
import scheduleRuleVuex from '../../../vuex/common';

const ruleType: ScheduleRuleType | undefined = undefined; 

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    RuleTypeBox,
  },
  data() {
    return {
      ruleType,
      ScheduleRuleType,
      hackId: 0,
    };
  },
  computed: {
    isVerifiedService(): boolean {
      return this.accountState.account.weixinType === 1 &&
             this.accountState.account.isVerified;
    },
  },
  methods: {
    initEventTriggered() {
      this.$store.commit('INIT_EVENT_TRIGGERED');
      this.hackId++;
    },
    initPeriodic() {
      this.$store.commit('INIT_PERIODIC');
      this.hackId++;
    },
    initTimeFieldBased() {
      this.$store.commit('INIT_TIME_FIELD_BASED');
      this.hackId++;
    },
  },
});
